// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backdrop {
    position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0,0,0,0.8);
      padding: 50px;
      z-index: 1;
}
.modal {
      background-color: #fff;
      border-radius: 5px;
      max-width: 500px;
      /* min-height: 300px; */
      margin: 0 auto;
      padding: 30px;
      display:flex;
      flex-direction: column;
      position: relative;
      z-index: 2;
}

.modal-content {
    flex: 1;
}

.modal-content h1 {
    flex: 1;
    color: var(--main-sub-color);
}

.modal-content hr {
    width: 80%;
    border-color:var(--main-sub-color);
}

.modal-footer {
    display: flex;
    justify-content: space-around;
}

.modal-footer button { 
    display: inline-block;
    outline: 0;
    cursor: pointer;
    border: 1px solid #1d1c1d4d;
    font-weight: 700;
    background: #FFF;
    padding: 0 8px 1px;
    font-size: 13px;
    border-radius: 26px;
    border: 1px solid #D4D3E8;
    color: var(--main-sub-color);
    text-transform: uppercase;
    box-shadow: 0px 2px 2px var(--main-sub-color);
    height: 28px;
    min-width: 56px;
    transition: .2s;
  }
  .modal-footer button:hover{
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 8%);
        background: rgba(248,248,248,1);
    }`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;MACb,MAAM;MACN,SAAS;MACT,OAAO;MACP,QAAQ;MACR,iCAAiC;MACjC,aAAa;MACb,UAAU;AAChB;AACA;MACM,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;MAChB,uBAAuB;MACvB,cAAc;MACd,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,UAAU;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,OAAO;IACP,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,6CAA6C;IAC7C,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;QACM,uCAAuC;QACvC,+BAA+B;IACnC","sourcesContent":[".backdrop {\r\n    position: fixed;\r\n      top: 0;\r\n      bottom: 0;\r\n      left: 0;\r\n      right: 0;\r\n      background-color: rgba(0,0,0,0.8);\r\n      padding: 50px;\r\n      z-index: 1;\r\n}\r\n.modal {\r\n      background-color: #fff;\r\n      border-radius: 5px;\r\n      max-width: 500px;\r\n      /* min-height: 300px; */\r\n      margin: 0 auto;\r\n      padding: 30px;\r\n      display:flex;\r\n      flex-direction: column;\r\n      position: relative;\r\n      z-index: 2;\r\n}\r\n\r\n.modal-content {\r\n    flex: 1;\r\n}\r\n\r\n.modal-content h1 {\r\n    flex: 1;\r\n    color: var(--main-sub-color);\r\n}\r\n\r\n.modal-content hr {\r\n    width: 80%;\r\n    border-color:var(--main-sub-color);\r\n}\r\n\r\n.modal-footer {\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n\r\n.modal-footer button { \r\n    display: inline-block;\r\n    outline: 0;\r\n    cursor: pointer;\r\n    border: 1px solid #1d1c1d4d;\r\n    font-weight: 700;\r\n    background: #FFF;\r\n    padding: 0 8px 1px;\r\n    font-size: 13px;\r\n    border-radius: 26px;\r\n    border: 1px solid #D4D3E8;\r\n    color: var(--main-sub-color);\r\n    text-transform: uppercase;\r\n    box-shadow: 0px 2px 2px var(--main-sub-color);\r\n    height: 28px;\r\n    min-width: 56px;\r\n    transition: .2s;\r\n  }\r\n  .modal-footer button:hover{\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 8%);\r\n        background: rgba(248,248,248,1);\r\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
